import { HeadlineS, Subtitle2 } from 'components/Text'
import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { useInView } from 'react-intersection-observer'
import gsap from 'gsap'

import Colors from 'styles/Colors'
import media from 'styles/media'
import { TextButton } from 'components/Buttons'
import { Link } from 'gatsby'

import design from 'src/assets/video/Design_v2-opt.mp4'
import commission from 'src/assets/video/Commission_v2-opt.mp4'
import production from 'src/assets/video/Production_v2-opt.mp4'
import run from 'src/assets/video/run.mp4'
import collaborate from 'src/assets/video/collaborate.mp4'

const TimerSVG: React.FC<{ cssClass: string }> = ({ cssClass }) => {
  return (
    <svg
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: 'rotate(-180deg)', overflow: 'visible' }}
    >
      <circle opacity="0.12" cx="25" cy="25" r="24" stroke="#141414" />
      <circle
        className={`${cssClass} how-it-works__timer`}
        cx="25"
        cy="25"
        r="24"
        stroke="#CE1212"
        strokeWidth="2"
      />
    </svg>
  )
}

const HowItWorks: React.FC<{}> = () => {
  const { ref, inView } = useInView({ threshold: 0.5 })
  const [step, setStep] = useState(1)
  const isFading = useRef(false)
  const fadedIn = useRef(true)
  const vid1: any = useRef()
  const vid2: any = useRef()
  const vid3: any = useRef()
  // const vid4: any = useRef()
  // const vid5: any = useRef()

  useEffect(() => {
    gsap.set('.how-it-works__timer', { drawSVG: '0' })
  }, [])

  useEffect(() => {
    if (inView) {
      vid1.current.play()
    }
  }, [inView])

  const handlePlay = (cssClass: string, ref: any) => {
    const percent = Math.ceil(
      (ref.current.currentTime / ref.current.duration) * 100
    )

    gsap.to(cssClass, { drawSVG: `${percent}%` })

    // if(ref.current.currentTime < 1 && !fadedIn) {
    //   gsap.to(`${cssClass}-callouts`, {opacity: 0, duration: 1, ease: 'none', onComplete: () => {
    //     isFading.current = false
    //   }})
    // }

    // if(ref.current.currentTime >= 11 && !isFading.current) {
    //   isFading.current = true
    //   gsap.to(`${cssClass}-callouts`, {opacity: 0, duration: 1, ease: 'none', onComplete: () => {
    //     isFading.current = false
    //   }})
    // }
  }

  const reset = () => {
    vid1.current.currentTime = 0
    vid2.current.currentTime = 0
    vid3.current.currentTime = 0
    // vid4.current.currentTime = 0
    // vid5.current.currentTime = 0
    vid1.current.pause()
    vid2.current.pause()
    vid3.current.pause()
    // vid4.current.pause()
    // vid5.current.pause()
    gsap.set('.how-it-works__timer', { drawSVG: '0' })
  }
  return (
    <Wrapper ref={ref}>
      <Video
        ref={vid1}
        controls={false}
        muted
        preload="auto"
        active={step === 1}
        onTimeUpdate={() => handlePlay('.how-it-works__step1', vid1)}
        onEnded={() => {
          vid2.current.play()
          setStep(2)
        }}
      >
        <source src={design} type="video/mp4" />
      </Video>
      <Video
        ref={vid2}
        controls={false}
        muted
        preload="auto"
        active={step === 2}
        onTimeUpdate={() => handlePlay('.how-it-works__step2', vid2)}
        onEnded={() => {
          vid3.current.play()
          setStep(3)
        }}
      >
        <source src={commission} type="video/mp4" />
      </Video>
      <Video
        ref={vid3}
        controls={false}
        muted
        preload="auto"
        active={step === 3}
        onTimeUpdate={() => handlePlay('.how-it-works__step3', vid3)}
        onEnded={() => {
          vid1.current.play()
          setStep(1)
        }}
      >
        <source src={production} type="video/mp4" />
      </Video>
      {/* <Video
        ref={vid4}
        controls={false}
        muted
        preload="auto"
        active={step === 4}
        onTimeUpdate={() => handlePlay('.how-it-works__step4', vid4)}
        onEnded={() => {
          vid5.current.play()
          setStep(5)
        }}
      >
        <source src={run} type="video/mp4" />
      </Video>
      <Video
        ref={vid5}
        controls={false}
        muted
        preload="auto"
        active={step === 5}
        onTimeUpdate={() => handlePlay('.how-it-works__step5', vid5)}
        onEnded={() => {
          vid1.current.play()
          setStep(1)
        }}
      >
        <source src={collaborate} type="video/mp4" />
      </Video> */}
      <Stepper>
        <Step
          onClick={() => {
            setStep(1)
            reset()

            vid1.current.play()
          }}
        >
          <Timer active={step === 1}>
            <TimerSVG cssClass={'how-it-works__step1'} />
          </Timer>
          <StepLabel>01</StepLabel>
          <StepText active={step === 1}>Design</StepText>
        </Step>
        <Step
          onClick={() => {
            setStep(2)
            reset()

            vid2.current.play()
          }}
        >
          <Timer active={step === 2}>
            <TimerSVG cssClass={'how-it-works__step2'} />
          </Timer>
          <StepLabel>02</StepLabel>
          <StepText active={step === 2}>Commission</StepText>
        </Step>
        <Step
          onClick={() => {
            setStep(3)
            reset()

            vid3.current.play()
          }}
        >
          <Timer active={step === 3}>
            <TimerSVG cssClass={'how-it-works__step3'} />
          </Timer>
          <StepLabel>03</StepLabel>
          <StepText active={step === 3}>Production</StepText>
        </Step>
        {/* <Step
          onClick={() => {
            setStep(4)
            reset()

            vid4.current.play()
          }}
        >
          <Timer active={step === 4}>
            <TimerSVG cssClass={'how-it-works__step4'} />
          </Timer>
          <StepLabel>04</StepLabel>
          <StepText active={step === 4}>Run</StepText>
        </Step>
        <Step
          onClick={() => {
            setStep(5)
            reset()

            vid5.current.play()
          }}
        >
          <Timer active={step === 5}>
            <TimerSVG cssClass={'how-it-works__step5'} />
          </Timer>
          <StepLabel>05</StepLabel>
          <StepText active={step === 5}>Collaborate</StepText>
        </Step> */}
      </Stepper>
      <Callouts active={step === 1} className="how-it-works__step1-callouts">
        <Callout>Software for fast, collision-free robot programming.</Callout>
        <Callout>Efficient layout and sequence options and testing.</Callout>
        <Callout>
          Better proposals and designs that adapt to changes faster.
        </Callout>
        <Link to="/rapidplan-create/">
          <Button>Get Creating</Button>
        </Link>
      </Callouts>
      <Callouts active={step === 2} className="how-it-works__step2-callouts">
        <Callout>Tackle more complex applications with less effort.</Callout>
        <Callout>Streamline commissioning and implementing changes.</Callout>
        <Callout>
          Easily sync physical production environment with the virtual model.
        </Callout>
        <Link to="/rapidplan-control/">
          <Button>Initiate Motions</Button>
        </Link>
      </Callouts>
      <Callouts active={step === 3} className="how-it-works__step3-callouts">
        <Callout>
          Control multiple robots for automated collision avoidance and
          automated failure recovery.
        </Callout>
        <Callout>Triage unexpected runtime issues on the fly.</Callout>
        <Callout>Quickly update targets without requiring shutdowns.</Callout>
        <Link to="/rapidplan-control/">
          <Button>See Controls</Button>
        </Link>
      </Callouts>
      {/* <Callouts active={step === 4} className="how-it-works__step4-callouts">
        <Callout>Effortlessly handles real-time variability</Callout>
        <Callout>Confidence in safe, reliable motions.</Callout>
        <Callout>Automatically recover from faults.</Callout>
      </Callouts>
      <Callouts active={step === 5} className="how-it-works__step5-callouts">
        <Callout>
          Trajectories automatically adjust to maintain required clearance from
          people
        </Callout>
      </Callouts> */}
    </Wrapper>
  )
}

const Wrapper = styled.section`
  height: 48.8vw;
  position: relative;
  overflow: hidden;

  ${media.tabletLandscape} {
    display: none;
  }
`

const Stepper = styled.div`
  display: flex;
  margin: 3.3vw 0 0 3.7vw;
  position: absolute;
`
const Step = styled.button`
  position: relative;
  padding-left: 2vw;
  margin-right: 2vw;
  font-size: 2.1vw;
  font-weight: 500;
  letter-spacing: 0.0015em;
  color: ${Colors.trueBlack};
  height: 5.1vw;
  display: flex;
  align-items: flex-end;
  border: none;
  background: transparent;
  cursor: pointer;
  :focus {
    outline: transparent;
  }
`
const StepText = styled(HeadlineS)<{ active: boolean }>`
  font-weight: 500;
  text-fill-color: transparent;
  -webkit-background-clip: text;
  -moz-background-clip: text;
  -webkit-text-fill-color: transparent;
  -moz-text-fill-color: transparent;
  background-size: 100%;
  transition: background-color 800ms cubic-bezier(0.72, 0, 0.12, 1) 0;
  transition: -webkit-text-stroke-width 0ms linear 800ms;
  background-clip: text;
  background-color: ${(props) =>
    props.active ? 'rgba(0, 0, 0, 0)' : Colors.trueBlack};
  -webkit-text-stroke-width: ${(props) => (props.active ? '1px' : '0')};
  -webkit-text-stroke-color: ${Colors.trueBlack};
  padding-bottom: 1vw;
  z-index: 1;
`
const Timer = styled.div<{ active: boolean }>`
  width: 3vw;
  position: absolute;
  top: 0;
  left: 0;
  opacity: ${(props) => (props.active ? 1 : 0)};
  transition: opacity 0.8s;
  transition-timing-function: cubic-bezier(0.72, 0, 0.12, 1);
`
const StepLabel = styled.p`
  position: absolute;
  font-size: 0.8vw;
  line-height: 1.1428571428571428em;
  letter-spacing: 0.05357142857142857em;
  top: 1.1vw;
  left: 1vw;
`
const Video = styled.video<{ active: boolean }>`
  width: 80%;
  position: absolute;
  top: 9vw;
  left: 14vw;
  opacity: 1;
  opacity: ${(props) => (props.active ? 1 : 0)};
`
const Callouts = styled.div<{ active: boolean }>`
  width: 228px;
  position: absolute;
  top: 13.4vw;
  left: 96px;
  opacity: ${(props) => (props.active ? 1 : 0)};
  transition: opacity 1s cubic-bezier(0.72, 0, 0.12, 1);
  transition-delay: ${(props) => (props.active ? '.5s' : '0s')};
`
const Callout = styled(Subtitle2)`
  position: relative;
  margin-bottom: 24px;
  white-space: pre-line;
  ::before {
    content: '//';
    color: ${Colors.rossoCorsa};
    position: absolute;
    left: -22px;
    top: 0;
  }
`
const Button = styled(TextButton)`
  ${media.mobile} {
    width: 93.6vw;
  }
`
export default HowItWorks
